import { render, staticRenderFns } from "./GSelect.vue?vue&type=template&id=adb51fda&"
import script from "./GSelect.vue?vue&type=script&lang=js&"
export * from "./GSelect.vue?vue&type=script&lang=js&"
import style0 from "./GSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports